var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
    'font-semibold px-2 rounded-md w-max',
    _vm.active ? ("bg-" + _vm.background) : ("border border-" + _vm.background),
    _vm.active ? 'text-light' : ("text-" + _vm.background),
    _vm.active
      ? ("hover:bg-" + _vm.background + "-d-1 hover:border-" + _vm.background + "-d-2")
      : ("hover:text-" + _vm.background + "-d-2 hover:border-" + _vm.background + "-d-2"),
    _vm.large ? '' : 'w-full md:min-w-32 text-base py-2.5',
    {
      'py-4 text-lg w-full md:min-w-40': _vm.large,
      'rounded-full': _vm.chip
    }
  ],attrs:{"type":"button"}},_vm.$listeners),[_c('div',{staticClass:"flex items-center justify-center px-2"},[_c('AppIcon',{attrs:{"left":"","name":_vm.icon,"color":_vm.active ? 'light' : _vm.background}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }